(function(){
    // Intersection Observer
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const target = entry.target;
            if (entry.isIntersecting) {
                target.classList.add('animate');
                observer.unobserve(target);
            }
        });
    }, { threshold: [0.01,0.1,0.2] });
    const elements = document.querySelectorAll('.intersect');
    elements.forEach(element => {
        observer.observe(element);
    });
})()